import { useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useNotification } from "../../../../hooks/useNotification";
import { useAddOrderLinesToConsignmentMutation } from "../../../../store/apiSlice/orderApiSlice";
import { useGetConsignmentsSelectionQuery } from "../../../../store/apiSlice/shipmentApiSlice";
import { BlurModal } from "../components/BlurModal/BlurModal";
import { Button } from "../components/Button/Button";
import { ModalHeader } from "../components/PurchaseOrderDetails/TrackingStatus";

export const AddToShipment = ({ closeModal, ordersName, allocation, setSelectedOrder }) => {
  const [selectShipment, setSelectShipment] = useState(null);
  const [addOrderLineToConsignment] = useAddOrderLinesToConsignmentMutation();
  useGetConsignmentsSelectionQuery(`type=${allocation}`);
  const consignmentsSelection = useSelector(state => state.shipment.consignmentsSelection);

  const notify = useNotification();

  const handleSubmit = async () => {
    if (!selectShipment) return;
    try {
      await addOrderLineToConsignment({
        consignment_id: selectShipment,
        [allocation === "purchase" ? "po_line_ids" : "tf_ord_line_ids"]: ordersName,
      }).unwrap();
      setSelectedOrder([]);

      notify({
        type: "success",
        message: `Successfully added one or more ${allocation} order lines to shipment.`,
      });
      closeModal();
    } catch (error) {
      const detail = error?.data?.detail;
      notify({
        type: "error",
        message:
          (typeof detail === "string" && detail) ||
          (Array.isArray(detail) && detail.join(" ")) ||
          "Could not add lines to the shipment. Please try again.",
      });
    }
  };

  return (
    <BlurModal>
      <AddToShipmentCss>
        <ModalHeader headerName="Add To Shipment" closeModal={closeModal} />
        <DetailsOfOrder allocation={allocation} ordersName={ordersName} />
        <SelectShipment
          consignmentsSelection={consignmentsSelection}
          setSelectShipment={setSelectShipment}
          ordersName={ordersName}
          labelForInput={
            <>
              Shipment <span>*</span>
            </>
          }
          optionValOne={"Select a Shipment"}
        />

        <Button btnName="Submit" handler={() => handleSubmit()} classOfBtn="submitBtn" />
      </AddToShipmentCss>
    </BlurModal>
  );
};

export const DetailsOfOrder = ({ allocation, ordersName }) => {
  const { orderlineMapById } = useSelector(state => state.newTransferOrder);
  const selectAllocation = {
    purchase: "purchase_order",
    transfer: "transfer_order",
  };
  return (
    <DetailsOfOrderCss>
      <p>You are adding following {allocation} lines to a shipment.</p>
      <ul>
        {ordersName.length > 0 &&
          ordersName.map(order => (
            <li>
              {orderlineMapById[allocation][order][selectAllocation[allocation]].name} [{" "}
              {orderlineMapById[allocation][order].product.name} ]{" "}
            </li>
          ))}
      </ul>
    </DetailsOfOrderCss>
  );
};

export const SelectShipment = ({
  consignmentsSelection,
  setSelectShipment,
  labelForInput,
  optionValOne,
  selectedValue,
}) => {
  const handleSelect = e => {
    setSelectShipment(e.target.value);
  };
  return (
    <SelectShipmentCss className="selectDropDown">
      {labelForInput && <label htmlFor="selectShipment">{labelForInput} </label>}
      <select
        name="selectShipment"
        id="selectShipment"
        value={selectedValue}
        onChange={handleSelect}
      >
        {optionValOne && (
          <option value="" disabled selected hidden>
            {optionValOne}{" "}
          </option>
        )}
        {consignmentsSelection.length > 0 &&
          consignmentsSelection.map(item => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
      </select>
    </SelectShipmentCss>
  );
};

export const AddToShipmentCss = styled.div`
  width: 40vw;
  background-color: #fff;
  border-radius: 4px;
  > .submitBtn {
    margin: 16px;
  }
  > .submitBtnSelectShipment {
    margin: 0 16px 16px;
  }
`;
export const DetailsOfOrderCss = styled.div`
  padding: 16px 24px;
  color: var(--DARK-GREY, #0e0e2c);
  font-weight: 400;
  line-height: 22px;
  > ul {
    max-height: 30vh;
    overflow: auto;
    > li {
      list-style-position: inside;
    }
  }
`;
export const SelectShipmentCss = styled.div`
  color: var(--GREY, #4a4a68);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  > label > span {
    color: var(--DANGER, #cf324a);
  }
  > select {
    border-radius: 4px;
    border: 1px solid var(--LIGHT-ASH, #b9b9c6);
    background: var(--CLOUD, #fcfdfe);
    height: 32px;
    padding: 8px 4px 8px 8px;
    outline: none;
  }
`;
